import { addYears, format } from "date-fns";
import { IHttpClient } from "../../lib/http";

export async function regenPropertyInventoryCalendar(
  httpClient: IHttpClient,
  propertyTicker: string,
  token?: string
): Promise<void> {
  const startDateFormatted = format(new Date(), "yyyy-MM-dd");
  const endDateFormatted = format(addYears(new Date(), 1), "yyyy-MM-dd");
  return httpClient.put(
    `/api/hotel/${propertyTicker}/ari?startDate=${startDateFormatted}&endDate=${endDateFormatted}`,
    [],
    {
      headers: {
        "x-property": propertyTicker,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );
}

export async function regenPropertyCalendar(
  httpClient: IHttpClient,
  propertyTicker: string,
  token?: string
): Promise<void> {
  return httpClient.put(`/api/hotel/${propertyTicker}/ari/calendar`, undefined, {
    headers: {
      "x-property": propertyTicker,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
